import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { Font } from '../../../../../../../shared/components/Font';
import { SizedIconWithCircle } from '../../../../../../../shared/components/SizedIconWithCircle';
import { Text } from '../../../../../../../shared/components/Text';
import { TRANSACTION_TYPES_DEFINITIONS } from '../../../constants/constants';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const transactionTypeMobileFieldColumn = ({ flex }: { flex?: number }) => {
  const { customBorderRadius, palette } = useCustomTheme();

  return {
    flex: flex ?? 0.15,
    field: 'type',
    headerName: <Text strong tId={'TRANSACTION_TYPE'} />,
    disableOnRowClick: true,
    renderCell: (rowData: TransactionsListRowProps) => {
      return (
        <>
          <SizedIconWithCircle
            variant={'medium'}
            backgroundColor={palette.grey[50]}
            iconColor={palette.grey[500]}
            customBorderRadius={customBorderRadius.button}
            iconName={TRANSACTION_TYPES_DEFINITIONS[rowData.row.type].iconName}
            copyToClipboard={{ value: rowData.row.id, textId: 'COPY_TRANSACTION_ID' }}
          />
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={rowData.row.type} />
          </Font>
        </>
      );
    },
  };
};
